import { StyleSheet } from 'aphrodite';
import { brandPrimary, darkGrayFontColor, navigation, tagBackgroundColor, titles } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
	},
	content: {
		display: 'block',
		margin: '30px auto',
		width: '90%',
	},
	additionalInfoContainer: {
		padding: '20px 20px 0',
	},
	additionalInfoItem: {
		paddingRight: 30,
		width: 'auto',
		...CssSelectors.allChildren(
			{
				fontSize: 18,
				margin: 0,
			},
			'div'
		),
	},
	additionalInfoRecipients: {
		paddingBottom: 5,
		width: 'auto',
	},
	category: {
		background: tagBackgroundColor,
		borderRadius: 20,
		fontSize: 12,
		padding: '4px 10px',
	},
	closeFullCriteria: {
		':hover': {
			cursor: 'pointer',
		},
		position: 'absolute',
		right: 0,
		top: 0,
	},
	innerContainer: {
		height: '100%',
		width: '100%',
	},
	empty: {
		borderTop: '1px solid #d8d8d8',
		display: 'block',
		marginTop: 30,
		paddingTop: 30,
	},
	error: {
		':last-child': {
			borderBottom: 'none',
		},
		borderBottom: `1px solid ${navigation}`,
		color: '#858585',
		fontSize: 14,
		padding: '15px 0',
	},
	errorContainer: {
		display: 'block',
		marginLeft: 20,
	},
	errors: {
		marginTop: 15,
	},
	fullCriteria: {
		fontSize: 13,
		height: 300,
		opacity: 1,
		resize: 'none',
		width: '100%',
	},
	fullCriteriaContainer: {
		paddingLeft: 0,
		position: 'relative',
		width: '50%',
	},
	limit: {
		color: brandPrimary,
		fontSize: 32,
	},
	limitsContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-start',
		marginLeft: 20,
		gap: 20,
	},
	limitGroup: {
		display: 'flex',
		flexDirection: 'row', // Keeps Daily and Hourly limits side by side
		justifyContent: 'space-between',
		alignItems: 'center', // Aligns items horizontally
		gap: 40, // Increased gap for better spacing between groups
	},
	limitItem: {
		display: 'flex',
		flexDirection: 'row', // Aligns Daily and Hourly values in a single row
		gap: 10, // Adds spacing between Daily and Hourly values
	},
	limitTitle: {
		color: '#666',
		fontSize: 11,
		letterSpacing: 1.1,
		marginBottom: 4,
		textTransform: 'uppercase',
	},
	limitSection: {
		marginBottom: 20,
	},
	usageSection: {
		marginBottom: 20,
	},
	sectionTitle: {
		fontSize: 14,
		fontWeight: 'bold',
		color: '#333',
		marginBottom: 10,
	},
	noErrors: {
		color: navigation,
		letterSpacing: 1.1,
		marginTop: 30,
		textTransform: 'uppercase',
	},
	noneFound: {
		color: darkGrayFontColor,
		fontSize: 14,
		marginTop: 30,
		textAlign: 'center',
		width: '100%',
	},
	showFullCriteria: {
		':hover': {
			cursor: 'pointer',
		},
		fontSize: 11,
		marginLeft: 6,
	},
	tagTokenPrefix: {
		color: '#858585',
		fontSize: 14,
	},
	title: {
		alignItems: 'center',
		color: titles,
		display: 'flex',
		fontSize: 24,
		marginBottom: 20,
		marginLeft: 20,
	},

	titleContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		marginBottom: 20,
	},

	debugButton: {
		marginRight: 20,
	},
});
